import { render } from "./Language.vue?vue&type=template&id=133ea05e&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=133ea05e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-133ea05e"

export default script